// Site-wide constants for Rapallini

export const WHATSAPP_NUMBER = "447960207829";
export const WHATSAPP_MESSAGE =
  "Hi Chanel! I just saw the Magic Dress on your website and would love to see the current brochure and available prints.";

export const waLink = (extraText) => {
  const msg = extraText || WHATSAPP_MESSAGE;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_luxury-one-page/artifacts/dhsnecwd_20250907_113648.jpg";

// 6 silhouettes — mapped to the assets the user uploaded
export const LOOKS = [
  {
    id: "halterneck",
    number: "I",
    name: "The Halterneck",
    caption: "Tied at the nape. Effortless poise.",
    image:
      "https://customer-assets.emergentagent.com/job_luxury-one-page/artifacts/l6mrv91b_Halterneck%20dress%20style.png",
  },
  {
    id: "roman",
    number: "II",
    name: "The Roman",
    caption: "Belted. Sculpted. A gentle drape.",
    image:
      "https://customer-assets.emergentagent.com/job_luxury-one-page/artifacts/30qjw3p2_Roman%20dress%20style%20with%20belt.png",
  },
  {
    id: "crossover",
    number: "III",
    name: "The Crossover",
    caption: "Twisted at the décolleté. Soft drama.",
    image:
      "https://customer-assets.emergentagent.com/job_luxury-one-page/artifacts/y6rovvxl_Cross%20over%20dress%20with%20belt.png",
  },
  {
    id: "boobtube",
    number: "IV",
    name: "The Boobtube",
    caption: "A clean line. Bare shoulders.",
    image:
      "https://customer-assets.emergentagent.com/job_luxury-one-page/artifacts/dhsnecwd_20250907_113648.jpg",
  },
  {
    id: "skirt",
    number: "V",
    name: "The Skirt",
    caption: "Wrapped at the waist. Print forward.",
    image:
      "https://customer-assets.emergentagent.com/job_luxury-one-page/artifacts/ekm2gvyf_Skirt%20to%20the%20side.jpg",
  },
  {
    id: "one-shoulder",
    number: "VI",
    name: "The One-Shoulder",
    caption: "Asymmetric. Quietly confident.",
    image:
      "https://customer-assets.emergentagent.com/job_luxury-one-page/artifacts/l3m5myt9_Off%20the%20shoulder%20with%20belt.png",
  },
];

// Hero — portrait of Chanel Rapallini
export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_luxury-one-page/artifacts/c6snf4w2_Chanel%20Rapallini.png";

// Fabric swatches — real fabric imagery where available, stylised otherwise
export const SWATCHES = [
  {
    name: "Floral",
    image:
      "https://customer-assets.emergentagent.com/job_luxury-one-page/artifacts/32451oup_Floral.jpg",
    position: "center center",
  },
  {
    name: "Paisley",
    image:
      "https://customer-assets.emergentagent.com/job_luxury-one-page/artifacts/t71l61zj_Paisley.jpg",
  },
  {
    name: "Hawaiian",
    image:
      "https://customer-assets.emergentagent.com/job_luxury-one-page/artifacts/vyi13m07_20251209_115529.jpg",
  },
  {
    name: "Abstract",
    image:
      "https://customer-assets.emergentagent.com/job_luxury-one-page/artifacts/lnlwx2b4_Abstract.jpg",
  },
  {
    name: "Black & White",
    image:
      "https://customer-assets.emergentagent.com/job_luxury-one-page/artifacts/q4toxdme_Black%20and%20White.jpg",
  },
  {
    name: "Stripes",
    image:
      "https://customer-assets.emergentagent.com/job_luxury-one-page/artifacts/w9bfx951_Stripes.jpg",
  },
];
